import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { FaArrowLeft, FaCheckCircle } from 'react-icons/fa';
import Hero from '../components/Hero';
import service1Data from '../data/service1.json';
import service2Data from '../data/service2.json';
import './ServiceDetail.css';

const serviceMap: Record<string, typeof service1Data> = {
  'assess-existing-environment': service1Data,
  'operational-consulting-support': service2Data,
};

const ServiceDetail: React.FC = () => {
  const { serviceId } = useParams<{ serviceId: string }>();
  const data = serviceMap[serviceId || ''];

  if (!data) {
    return (
      <div className="not-found-page">
        <div className="container" style={{ textAlign: 'center', padding: '200px 24px 100px' }}>
          <h1>Service Not Found</h1>
          <p>The service you're looking for doesn't exist.</p>
          <Link to="/services" className="btn btn-primary" style={{ marginTop: '24px' }}>
            View All Services
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="service-detail-page">
      <Hero
        heading={data.hero.heading}
        subheading={data.hero.subheading}
        backgroundImage={data.hero.backgroundImage}
        compact
      />

      <section className="section">
        <div className="container">
          <Link to={data.backLink.path} className="back-link">
            <FaArrowLeft /> {data.backLink.text}
          </Link>

          <div className="sub-services">
            {data.subServices.map((sub, idx) => (
              <div key={idx} className="sub-service">
                <div className="sub-service-grid">
                  <div className={`sub-service-content ${idx % 2 === 1 ? 'order-2' : ''}`}>
                    <h3 className="sub-service-title">{sub.title}</h3>
                    <p className="sub-service-tagline">{sub.tagline}</p>

                    <div className="sub-service-block">
                      <h4>Why It's Important</h4>
                      <p>{sub.why}</p>
                    </div>

                    <div className="sub-service-block">
                      <h4>What You Get</h4>
                      <ul className="check-list">
                        {sub.whatYouGet.map((item, i) => (
                          <li key={i}>
                            <FaCheckCircle className="check-icon" />
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="sub-service-block">
                      <h4>How We Do It</h4>
                      <p>{sub.howWeDoIt}</p>
                    </div>
                  </div>

                  <div className={`sub-service-image ${idx % 2 === 1 ? 'order-1' : ''}`}>
                    <img src={sub.image} alt={sub.title} loading="lazy" />
                  </div>
                </div>

                {idx < data.subServices.length - 1 && <hr className="sub-service-divider" />}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetail;
